import "./ProjectHeroWeatherForecaster.scss";

function ProjectHeroWeatherForecaster() {
  return (
    <>
      <section class="project-cs-hero">
        <div class="project-cs-hero__content">
          <h1 class="heading-primary">Weather Forecaster</h1>
          <div class="project-cs-hero__info">
            <p class="text-primary text-primary--project">
              This is a web application for getting real-time weather
              information.
            </p>
          </div>
          <div class="project-cs-hero__cta">
            <a
              href="https://supreet-kaur-weather-forecaster.netlify.app/"
              class="btn btn--bg"
              target="_blank"
              rel="noreferrer"
            >
              Live Link
            </a>
          </div>
        </div>
      </section>
    </>
  );
}

export default ProjectHeroWeatherForecaster;
